import React from 'react'
import { Pagination as PaginationAntd } from 'antd'
import { Box } from '../Box'

export const Pagination = ({
	itemsTotal,
	onChange,
	page,
	pageSize,
	disible,
}) => {
	return !disible ? (
		<Box style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
			<PaginationAntd
				total={itemsTotal}
				showTotal={(total) => `Total ${total} items`}
				defaultCurrent={page}
				defaultPageSize={pageSize}
				pageSizeOptions={[10, 20, 50]}
				onChange={onChange}
			/>
		</Box>
	) : null
}
